goog.provide("shadow.js.shim.module$src$svg$path$path_svg");
goog.provide("module$shadow_js_shim_module$src$svg$path$path_svg");
shadow.js.shim.module$src$svg$path$path_svg = shadow.js.nativeProvides["src/svg/path/path.svg"] = shadow$bridge("src/svg/path/path.svg");
module$shadow_js_shim_module$src$svg$path$path_svg.default = shadow.js.shim.module$src$svg$path$path_svg;
